'use client'
import React from 'react'
import { useRouter } from "next/navigation";
import MaterialButton from "@/components/ui/buttons/global/MaterialButton";

const ErrorInternalPage = () => {

    const router = useRouter();

    return (
        <div className={'min-h-screen flex items-center justify-center'}>
            <div className={'space-y-2'}>
                <h3 className={'text-3xl font-bold'}>Internal Error</h3>
                <p>{"This page isn't working"}</p>
                <MaterialButton text={"Go Back"} onClick={_ => {
                    router.back();
                }}/>
            </div>
        </div>
    );
};

export default ErrorInternalPage;